(function () {
  var config = window.base_selector;
  if (!config) return;

  var options = [
    { title: config.strings.anchor,           image: config.images.anchor           },
    { title: config.strings.displaced_anchor, image: config.images.displaced_anchor },
    { title: config.strings.stake,            image: config.images.stake            }
  ];

  var selectedIndex = 0;

  function init() {
    var wrapper = document.getElementById('base-selector');
    if (!wrapper) return;

    var root = document.createElement('div');
    root.className = 'base-selector';

    var hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = 'properties[' + config.label + ']';
    hiddenInput.value = options[selectedIndex].title;
    hiddenInput.setAttribute('form', 'product-form-' + config.sectionId);

    options.forEach(function (option, index) {
      var tile = document.createElement('div');
      tile.className = 'base-selector__option';
      if (index === selectedIndex) tile.classList.add('base-selector__option--selected');

      var img = document.createElement('img');
      img.src = option.image;
      img.alt = option.title;
      img.width = 60;
      img.height = 40;

      var title = document.createElement('div');
      title.className = 'base-selector__title';
      title.textContent = option.title;

      tile.appendChild(img);
      tile.appendChild(title);

      tile.addEventListener('click', function () {
        selectedIndex = index;
        hiddenInput.value = options[selectedIndex].title;

        root.querySelectorAll('.base-selector__option').forEach(function (el, i) {
          el.classList.toggle('base-selector__option--selected', i === selectedIndex);
        });

        window.dispatchEvent(new CustomEvent('baseSelectorChange', {
          detail: { base: options[selectedIndex].title, index: selectedIndex }
        }));
      });

      root.appendChild(tile);
    });

    wrapper.appendChild(root);
    wrapper.appendChild(hiddenInput);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
